import { useMemo } from 'react';
import type { Item } from './api.ts';
import { readProgressDraft, resolveResumeWithDraft } from './progressDraft.ts';
import { useSession } from './session.tsx';

/**
 * İzleme ekranının kullanıcı ve başlangıç konumu (V6-10).
 *
 * Yerel taslak yalnız hesap/içerik değiştiğinde bir kez okunur; oynatma
 * sırasında konum her saniye değişse de başlangıç noktası kaymaz.
 */
export function useWatchResume(
  item: Item,
  startOver: boolean,
): { userId: string | null; resumeMs: number } {
  const { user } = useSession();
  const draft = useMemo(
    () => (user === null ? null : readProgressDraft(user.id, item.id)),
    [user, item.id],
  );
  return {
    userId: user?.id ?? null,
    resumeMs: startOver ? 0 : resolveResumeWithDraft(item, draft),
  };
}
